import modalHeader from 'components/modal/modal-types/shared/modal-header'
// import modalButton from 'components/modal/modal-types/shared/modal-button'
import modalTable from 'components/modal/modal-types/shared/modal-table'
import { dictionary } from 'helpers/dictionary'
import format from 'date-fns/format'
import { is } from 'date-fns/locale'
import { parsePortName } from 'components/sailing-schedule/sailing-schedule-utils'

// import compass from 'assets/svg/icon-compass.svg'

const modalPort = {
  async render({ id, line }) {
    const req = await fetch(`/webapi/sailingschedule/voyage?id=${id}&line=${line}&rand=${new Date()}`)
    const res = await req.json()

    if (!req.ok) {
      return
    }

    const data = res.find((item) => item?.lineName === line)

    if (!data) {
      return
    }

    // const sailingSchedule = document.querySelector<HTMLElement>('.sailing-schedule')

    return `
      ${modalHeader.render({ text: data?.lineName })}
      <div class="modal__voyage-info">
        ${this.renderVoyageInfoItem({
          label: dictionary('scVoyageNumber'),
          value: data?.voyageNumber,
        })}
        ${this.renderVoyageInfoItem({
          label: dictionary('scVessel'),
          value: data?.vesselName,
        })}
        ${this.renderVoyageInfoItem({
          label: dictionary('scFlag'),
          value: data?.vesselFlag,
        })}
      </div>
      <div class="modal__table">
        ${modalTable.render({
          body: this.handleTableBody({ data: data?.portSchedules }),
          thead: [dictionary('scHarbour'), dictionary('scArrival'), dictionary('scDeparture')],
        })}
      </div>
    `
  },

  handleTableBody({ data }) {
    if (data === null) {
      return
    }

    const list = []

    for (let i = 0; i < data.length; i++) {
      const rowList = []
      const obj = data[i]

      for (const key in obj) {
        switch (key) {
          case 'portName':
            rowList[0] = parsePortName(obj[key])
            break
          case 'arrivalTime':
            rowList[3] = format(new Date(obj[key]), 'dd. MMM - HH:mm', { locale: is })
            break
          case 'departureTime':
            rowList[4] = format(new Date(obj[key]), 'dd. MMM - HH:mm', { locale: is })
            break
        }
      }

      list.push(rowList)
    }

    return list
  },

  renderVoyageInfoItem({ label, value }) {
    return `
      <div class="modal__voyage-info-item">
        <span class="body6">${label}</span>
        <span class="body2 bold">${value}</span>
      </div>
    `
  },
}

export default modalPort
